import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './ui/auth/services/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./ui/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./ui/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: 'leaderboard/fullscreen',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./ui/leaderboard/leaderboard-fullscreen/leaderboard-fullscreen.module').then(
        (m) => m.LeaderboardFullscreenModule
      ),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./ui/shell/shell.module').then((m) => m.ShellModule),
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
